(function () {
    'use strict';

    angular
        .module('cacmEventModule')
        .controller('FindCACMEventGroupController', Controller);

    Controller.$inject = ['$scope', 'pagerService'];

    function Controller($scope, pagerService) {
        $scope.pager = pagerService.newPager({ numberOfItemsPerPage: 5 });
        $scope.pager.updatePagerFromItems($scope.results);

        $scope.selectItem = function (item) {
            $scope.onSelect(item);
        };
    }
})();